import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { UseUnauthorisedHandlerState } from './types';

export const initialState: UseUnauthorisedHandlerState = {
  unauthorised: false,
};

const slice = createSlice({
  name: 'useUnauthorisedHandler',
  initialState,
  reducers: {
    setUnauthorised(state, action: PayloadAction<boolean>) {
      state.unauthorised = action.payload;
    },
  },
});

export const {
  actions: useUnauthorisedHandlerActions,
  reducer: useUnauthorisedHandlerReducer,
} = slice;

export const useUseUnauthorisedHandlerSlice = () => ({
  actions: slice.actions,
});

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useUseUnauthorisedHandlerSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
